import { ROUTE } from './constantsDefault'
export const SIDEBAR = {
  LOGOUT: {
    TH: 'ออกจากระบบ',
    EN: 'Logout'
  }
}

export const MENU = {
  MY_CALENDAR: {
    TH: 'ปฏิทินของฉัน',
    EN: 'My Calendar',
    LINK: ROUTE.CALENDAR.LINK,
    CODE: 'read_booking_view_calendar'
  },
  MEETING_ROOM: {
    TH: 'พื้นที่การประชุม',
    EN: 'Meeting Spaces',
    LINK: ROUTE.MEETING_ROOM.LIST,
    CODE: 'read_booking_view_meeting_room'
  },
  FLOOR_PLAN: {
    TH: 'แผนผังชั้น',
    EN: 'Floor Plan',
    LINK: ROUTE.FLOORPLAN.LINK,
    CODE: 'read_booking_view_floor_plan'
  },
  SETTING: {
    TH: 'ตั้งค่า',
    EN: 'Setting',
    LINK: ROUTE.USER_SETTING.LINK,
    CODE: 'read_localization_setting'
  }
}
